module.exports = __webpack_public_path__ + "a157456c549e7772c120a6183a4aa27e.pdf";